import React, { ReactNode } from 'react';
import styled from 'styled-components';
import Layout from './Layout';
import SEO from './SEO';
import Section from './Section';

interface LegalPageLayoutProps {
  title: string;
  description: string;
  children: ReactNode;
  canonical: string;
}

const LegalContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const LegalTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 2rem;
`;

const LegalPageLayout: React.FC<LegalPageLayoutProps> = ({ 
  title, 
  description, 
  children,
  canonical 
}) => {
  return (
    <Layout>
      <SEO 
        title={`${title} | Web a Bajo Coste`}
        description={description}
        canonical={canonical}
      />
      
      <Section background="light">
        <LegalContainer>
          <LegalTitle>{title}</LegalTitle>
          {children}
        </LegalContainer>
      </Section>
    </Layout>
  );
};

// Componentes adicionales para usar en las páginas legales
export const LegalSection = styled.div`
  margin-bottom: 2.5rem;
`;

export const LegalSubtitle = styled.h2`
  font-size: 1.75rem;
  margin-bottom: 1.25rem;
  color: var(--gray-dark);
`;

export const LegalText = styled.p`
  margin-bottom: 1rem;
  color: var(--gray);
  line-height: 1.6;
`;

export const LegalList = styled.ul`
  margin-bottom: 1.5rem;
  padding-left: 1.5rem;
  
  li {
    margin-bottom: 0.75rem;
    color: var(--gray);
    line-height: 1.6;
  }
`;

export default LegalPageLayout; 